export enum CommonEnum {
    Ranking = 'ranking',
    Rewards = 'rewards',
}
